<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "departments",
  data() {
    return {};
  },
  created() {}
};
</script>
